/**
 * alertBanner
 *
 * Component code for alert banner functionality
 *
 * @since 2.0.0
 */
window.alertBanner = (items, delay) => {
	return {
		/**
		 * Number of alert items to rotate through.
		 * @type {number}
		 */
		numItems: items || 0,

		/**
		 * Index of the currently active alert item.
		 * @type {number}
		 */
		activeItem: 0,

		/**
		 * Delay in milliseconds between alert item rotations.
		 * @type {number}
		 */
		delay: delay || 4000,

		/**
		 * Initialize the alert banner.
		 *
		 * @author owendixon
		 */
		init() {
			if (this.numItems > 1) {
				this.startMarquee();
			}
		},

		/**
		 * Start the automatic rotation marquee for multiple alert items.
		 *
		 * @author owendixon
		 */
		startMarquee() {
			setInterval(() => {
				// Update activeItem index, but once we reach the end, loop back to 0. OD
				this.activeItem = this.activeItem + 1 < this.numItems ? this.activeItem + 1 : 0;
			}, this.delay);
		},
	};
};

document.addEventListener('alpine:init', () => {
	Alpine.data('alertBanner', (items, delay) => window.alertBanner(items, delay));
});
